import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';

import PodcastForm from '../../components/form/PodcastForm';



const Podcast = () => {
    return (
        <>
            <SEO title="Podcast" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* This is the Service Categories Area */}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <PodcastForm />
                    </div>
                </div>


                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Podcast
